import Record from '../transits/Record';
import Transit from '../transits/Transit';
import Cost from '../cost/Cost';

class CsvRecord implements Record {
  type: string;
  from: Transit;
  to: Transit;
  cost: Cost;
  constructor($type: string, $from: Transit, $to: Transit, $cost: Cost) {
    this.type = $type;
    this.from = $from;
    this.to = $to;
    this.cost = $cost;
  }
}

export default CsvRecord;



// WEBPACK FOOTER //
// ./src/logic/domain/csv/CsvRecord.ts